import React, { useState, useEffect } from 'react';
import './paymentTable.css';

interface User {
    id: number;
    name: string;
    balance: number;
}

interface PaymentTableProps {
    setSelectedUsersId: (users: number[]) => void;
    users: User[];
    isReadOnly?: boolean;
}

const PaymentTable: React.FC<PaymentTableProps> = ({ users, setSelectedUsersId, isReadOnly = false }) => {
    const [selectedUsersId, setSelectedUsersIdState] = useState<number[]>([]);

    const handleCheckboxChange = (userId: number): void => {
        setSelectedUsersIdState(prevState => {
            if (prevState.includes(userId)) {
                return prevState.filter(id => id !== userId);
            } else {
                return [...prevState, userId];
            }
        });
    };

    useEffect(() => {
        setSelectedUsersId(selectedUsersId);
    }, [selectedUsersId, setSelectedUsersId]);

    const formatBalance = (balance: number): string => {
        if (balance === 0 || balance === -0) return '0';
        const formattedBalance = balance.toFixed(1);
        return formattedBalance.endsWith('.0') ? formattedBalance.slice(0, -2) : formattedBalance;
    };
    const totalBalance = users.reduce((sum, user) => sum + user.balance, 0);

    return (
        <div className="payment-list-container">
            <div className="payment-list-header">
                <div className="header-item">שם</div>
                <div className="header-item">יתרה</div>
                {!isReadOnly && <div className="header-item">השתתף</div>}
            </div>
            <div className="payment-list-body">
                {users.map((user) => (
                    <div key={user.id} className="payment-list-row">
                        <div className="row-item name-cell">{user.name}</div>
                        <div className={`row-item amount-cell ${user.balance > 0 ? 'amount-positive' : user.balance < 0 ? 'amount-negative' : ''}`}>
                            {formatBalance(user.balance)}
                        </div>
                        {!isReadOnly && (
                            <div className="row-item checkbox-cell">
                                <input
                                    type="checkbox"
                                    checked={selectedUsersId.includes(user.id)}
                                    onChange={() => handleCheckboxChange(user.id)}
                                    className="user-checkbox"
                                />
                            </div>
                        )}
                    </div>
                ))}
            </div>
            <div className="payment-list-footer">
                <div className="footer-item">סך הכל</div>
                <div className="footer-item  amount-cell">{formatBalance(totalBalance)}</div>
                {!isReadOnly && <div className="footer-item"></div>}
            </div>
        </div>
    );
};

export default PaymentTable;